module.exports = "/virtual-football-league/img/amblems/left/logos/Fake_Burnley.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Fake_Burnley.png
// module id = 2079
// module chunks = 4